import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useFetch } from 'hooks/useFetch'

export type UseCouponsReturn = {
  lastModifiedUtc?: Date
  utmSource: string
  utmCampaign: string
  couponCode: string
  isArchived: boolean
  maxItemsPerClient: number
  expirationIntervalPerUse: string
  maxUsage: number
}

type Params = {
  id: string
  options?: Partial<UseQueryOptions<UseCouponsReturn>>
}

export function useCouponQuery(params: Params) {
  const { id, options } = params

  const { fetcherWrapper } = useFetch()

  const url = new URL(
    `/api/proxy/rnb/pvt/coupon/${id}`,
    window.location.origin
  ).toString()

  async function fetcher(): Promise<UseCouponsReturn> {
    return fetcherWrapper(url).then((r) => r.json())
  }

  return useQuery<UseCouponsReturn>({
    queryKey: ['coupon-by-id', id],
    queryFn: fetcher,
    ...options,
    refetchOnMount: false,
    retry: false,
  })
}
